import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateAndSendFlexModCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});
export const GenerateAndSendFlexModCancellationNoticeSideEffect =
  GenerateAndSendFlexModCancellationNoticeSideEffectContext.extend({
    type: z.literal('generateAndSendFlexModCancellationNotice'),
  });
export type GenerateAndSendFlexModCancellationNoticeSideEffect = z.infer<
  typeof GenerateAndSendFlexModCancellationNoticeSideEffect
>;
